import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';

export const shoppingCartSliceReducer = createSlice({
  name: 'shoppingCart',
  initialState,
  reducers: {},
});

export default shoppingCartSliceReducer.reducer;
